import { Component, OnInit } from '@angular/core';
import { DoubleOptInApiService } from '../double-opt-in-api-service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-double-opt-in-confirm',
    templateUrl: './double-opt-in-confirm.component.html',
    styleUrls: ['./double-opt-in-confirm.component.scss'],
    standalone: false
})
export class DoubleOptInConfirmComponent implements OnInit {
  talentId: string = this.route.snapshot.queryParams['talentId'];
  talentEmail: string = this.route.snapshot.queryParams['email'];

  constructor(private route: ActivatedRoute, private doubleOptInApi: DoubleOptInApiService) {}

  ngOnInit(): void {
    this.doubleOptInApi.saveDoubleOptInStatus(this.talentId, this.talentEmail).subscribe(
      () => {},
      (error) => {console.log('Could not save Double Opt-In Status: ' + error)}
    );
  }
}
